import { useLayoutEffect, useRef, memo } from "react";
import useEsri from "../hooks/useEsri";
import { loadModules } from "esri-loader";

const GBMapSearch = memo(({ onSearchComplete }) => {
  const { esriLoader } = useEsri();
  const searchRef = useRef();

  useLayoutEffect(() => {
    if (!esriLoader) return;
    const modulesToLoad = ["esri/widgets/Search", "esri/tasks/Locator"];
    loadModules(modulesToLoad).then(([Search, Locator]) => {
      const searchWidget = new Search({
        view: esriLoader.view,
        container: searchRef.current,
        sources: [
          {
            locator: new Locator({
              url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer",
            }),
            countryCode: "GB",
            placeholder: "Enter postcode or place",
            maxResults: 3,
            maxSuggestions: 6,
            suggestionsEnabled: true,
            minSuggestCharacters: 0,
          },
        ],
        includeDefaultSources: false,
        autoSelect: true,
      });

      if (onSearchComplete) {
        searchWidget.on("search-complete", function (event) {
          onSearchComplete(event);
        });
      }
    });

    return () => {};
  }, [esriLoader, onSearchComplete]);

  return (
    <div className="esri-map-search">
      <div ref={searchRef}></div>
    </div>
  );
});

export default GBMapSearch;
